export const BROWSE = {
  browseFilterApplied: 'Browse - Filter applied on Browse Map',
  viewDrawerOrg: 'Browse - Opened Organization Details',
};

export const LOGIN = {
  session: 'Login - New Session',
};

export const MY_NETWORKS = {
  shareClicked: 'My Networks - Shared Org Info',
};

const eventConstants = {
  BROWSE,
  LOGIN,
  MY_NETWORKS,
};

export default eventConstants;
